import { Model } from './model';
import { Transform, Type } from 'class-transformer';
import { ApPortal } from './ap_portal';
import { type ApPortalProvider, ApPortalNameMap } from './ap_portal';

export interface CreateApPortalAccountSchema {
  provider: string;

  username: string;

  password: string;

  header_token: string;
}

export class ApPortalAccount extends Model {
  id: string;

  provider: ApPortalProvider;

  username: string;

  organization_id: string;

  header_token: string;

  @Type(() => ApPortal)
  ap_portals: ApPortal[];

  get providerName() {
    return (ApPortalNameMap[this.provider] || this.provider) as string;
  }
}
